import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
  name: 'markdown',
  standalone: true,
})
export class MarkdownPipe implements PipeTransform {
  transform(value: any, args?: any[]): any {
    if (value && value.length > 0) {
      let options: marked.MarkedOptions = {
        headerIds: false,
        headerPrefix: '',
      };
      return marked(value, options);
    }
    return value;
  }
}
